
import {  fileServer, serverUrl } from "../configs/server";

//login
export const userAuth = (email, password) => {
    return fetch(`${serverUrl}/accounts/login`, {
        method: "POST",
        body: JSON.stringify({email, password}),
        headers: {
            "Content-Type" : "application/json",
            "Accept" : "application/json",
        },
    });
}


//third party auth from app server
export const googleAuthentication = (data) => {
    return fetch (`${serverUrl}/accounts/googleauth`,{
        method: "POST",
        headers: {
             Accept: 'application/json',
             "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })
}

//goole auth with google servers
export const googleAuthPromise = (token) => {
    return fetch (`
        https://www.googleapis.com/oauth2/v1/userinfo?access_token=${token}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
        }
    })
}

//register
export const userRegistration = (data) => {
    return fetch(`${serverUrl}/accounts/register`, {
        method: "POST",
        body: JSON.stringify(data),
        headers:{
            "Content-Type" : "application/json",
            "Accept" : "application/json",
        },
    })
}

//get userdata
export const getUserData = (token) => {
   return fetch(`${serverUrl}/accounts/myaccount`,{
    method: "GET",
    headers: {
        "Accept" : "application/json",
        "Authorization" : `Bearer ${token}`
    },
   })

}

//logout
export const userLogout = (token) => {
    return fetch(`${serverUrl}/accounts/logout`, {
        method: "POST",
        headers: {
            "Accept" : "application/json",
            "Authorization" : `Bearer ${token}`
        }
    })
}

//delete my account
export const deleteAcc = (token, username) => {
    return fetch (`${serverUrl}/accounts/harddelete`,{
        method: 'DELETE',
        headers: {
            "Content-Type" : "application/json",
            "Authorization" : `Bearer ${token}`
        },
        body: JSON.stringify({username})
    })
}


//get all questions
export const getQuestions = () => {
    return fetch (`${serverUrl}/accounts/allquestions`,{
        method: "GET",
        headers: {
            Accept: "application/json",
        }
    });
};

//ask question
export const askPeerQuestion = (token, data) => {
    return fetch(`${serverUrl}/accounts/post_question`,{
        method: "POST",
        body: JSON.stringify(data),
        headers:{
            "Content-Type" : "application/json",
            "Accept" : "application/json",
            Authorization: `Bearer ${token}`
        },
    })
}

//ask ai
export const askAiQuestion = (token, question) => {
    return fetch(`${serverUrl}/accounts/chatAI`,{
        method: "POST",
        body: JSON.stringify({
            content: question
        }),

        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
        }
    });
}

export const answerQuestion = (data, token) => {
    return fetch (`${serverUrl}/accounts/answer`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
}


//get answers to a particular question
export const getAnswers = (id) => {
    return fetch(`${serverUrl}/accounts/answers/${id}`,{
        method: "GET",
        headers: {
            Accept: "application/json",
        }
    });
};


//update account info
export const updateAccount = (data, token) => {

    return fetch (`${serverUrl}/accounts/update`,{
        method: "PATCH",
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': "application/json"
        },
        body: JSON.stringify(data),
        mode: "cors"
    }) 
}

//add user avatar
export const uploadAvatar = (data) => {
    const formData = new FormData();
    console.log({image: data.imageFile});
    formData.append("avatar", data.imageFile);
    return fetch (`${fileServer}/accounts/avatar`,{
        method: "POST",
        body: formData,
        mode: "cors"
    })
}


//send recovery email
export const sendRecoveryEmail = (email) => {
    return fetch (`${serverUrl}/accounts/recoverymail`,{
        method: "POST",
        body: JSON.stringify({ email }),
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
        }
    })
}

/** reset user password */
export const createNewPassword = (password,repeatedPassword, token) => {
    console.log({password,repeatedPassword, token})
    return fetch (`${serverUrl}/accounts/changepassword/${token}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            password,
            repeatedPassword
        }),
        mode: "cors"
    })
}

//save answer from ai
export const saveAiAnswer = (data, token) => {
    return fetch (`${serverUrl}/accounts/aianswer`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
}

/** add user as admin */
export const addUserAsAdmin = (token, email) => {
    return fetch (`${serverUrl}/accounts/toadmin/${email}`,{
        method: "PATCH",
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
}

/** subscribe to hnd past questions */
export const subscribeHND = (email, token) => {
    return fetch (`${serverUrl}/accounts/pqsubscribe`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ email }),
        mode: "cors"
    })
}

/** get hnd subscribers */
export const allHNDSubscribers = (token) => {
    return fetch (`${serverUrl}/tutorial/hndsubscribers`,{
        method: "GET",
        headers: {
            "Authorization": `Bearer ${token}`
        },
        mode: "cors"
    })
}

/** get tutorial subscribers */
export const allTutorialSubscribers = (token) => {
    return fetch (`${serverUrl}/tutorial/subscribers`,{
        method: "GET",
        headers: {
            "Authorization": `Bearer ${token}`
        },
        mode: "cors"
    })
}

/** announce an update */
export const updateAnnouncement = (data, token) => {
    return fetch (`${serverUrl}/accounts//verion-update`,{
        method: "PATCH",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        mode: 'cors',
        body: JSON.stringify(data)
    })
}